module.exports = __webpack_public_path__ + "static/img/notification.0ec40d41.svg";